import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 150px 15px 230px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const Title = styled(Typography.Title).attrs({ $variant: '4' })`
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 20px;
  text-align: center;
`;

export const SubTitle = styled(Typography.Body)`
  text-align: center;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;
